import React from 'react';
import getSymbolFromCurrency from 'currency-symbol-map'
import useGlobal from '../../store';

const CurrencySymbol = (props) => {
    
    const [user] = useGlobal(
        state => state.user
    );

    const symbol = getSymbolFromCurrency(user ? user.currency : 'USD');

    return (<>{symbol}</>);
}
export default CurrencySymbol;